<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.SET_EVAL_ITEM')}}<!--검사항목 설정-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{$t('AUDIT.LABEL.CASE.MODIFY_POLICY')}}<!--검사항목 수정-->&nbsp;:&nbsp;
                <a href="#">{{getAuditName(histItem)}}
                    <!--<template v-if="evntLog !== null && chkDiffWtlList">: {{evntLog.wtlTitl}} {{$t('AUDIT.LABEL.CASE.MODIFY')}}&lt;!&ndash;수정&ndash;&gt;</template>-->
                </a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && evntLog == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="evntLog !== null">
                <caption>{{ $t('AUDIT.FILTER.CHANGE_ASSESSMENT_ITEM')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.FROM')}}<!--변경 전--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.TO')}}<!--변경 후--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <!-- {{evntLog.enTitle}} -->
                    <th>{{ $t('AUDIT.INSPECTION.NAME')}}<!--이름--></th>
                    <td>{{bfEvntLog[$i18n.locale+'Title']!=null ? bfEvntLog[$i18n.locale+'Title'][0]:bfEvntLog.plcyTitl}}</td>
                    <td v-if="chkDiffTitl"><ins>{{evntLog[$i18n.locale+'Title']!=null?evntLog[$i18n.locale+'Title']:evntLog.plcyTitl}}</ins></td>
                    <td v-else>{{evntLog[$i18n.locale+'Title']!=null?evntLog[$i18n.locale+'Title'][0]:evntLog.plcyTitl}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.DESCRIPTION')}}<!--설명--></th>
                    <td>{{evntLog[$i18n.locale+'Desc']!=null ?evntLog[$i18n.locale+'Desc'][0]: bfEvntLog.plcyDesc}}</td>
                    <td v-if="chkDiffDesc"><ins>{{evntLog[$i18n.locale+'Desc']!=null? evntLog[$i18n.locale+'Desc'][0]:evntLog.plcyDesc}}</ins></td>
                    <td v-else>{{evntLog[$i18n.locale+'Desc']!=null?evntLog[$i18n.locale+'Desc'][0]:evntLog.plcyDesc}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.APPLIED_RULES')}}<!--적용된 규칙--></th>
                    <td>
                        <span v-if="bfEvntLog[$i18n.locale+'RuleTitle'] !==null" v-for="bTitl of bfEvntLog[$i18n.locale+'RuleTitle']" class="item">{{bTitl}}</span>
                        <span v-else v-for="bTitl of bfEvntLog.ruleTitl" class="item">{{bTitl}}</span>
                    </td>
                    <td>
                        <span v-if="evntLog[$i18n.locale+'RuleTitle'] !==null" v-for="bTitl of evntLog[$i18n.locale+'RuleTitle']" class="item">{{bTitl}}</span>
                        <span v-else v-for="bTitl of evntLog.ruleTitl" class="item">{{bTitl}}</span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.AUTOMATIC_EVAL_SCHEDULE')}}<!--자동검사 스케줄--></th>
                    <td>
                        <span class="item" v-if="bfEvntLog.execType == 'A' && bfEvntLog.schdDt !== null"><time datetime="">{{bfEvntLog.schdDt}}</time></span>
                        <span class="item">{{bfEvntLog.rprtYn == 'Y' ? $t('AUDIT.INSPECTION.SEND_REPORT') : $t('AUDIT.INSPECTION.REPORT_NOT_RECEIVED')}} <!--(<time datetime="">yyyy-mm-dd 00:00:00 발송</time>)--></span>
                    </td>
                    <td>
                        <span class="item" v-if="evntLog.execType == 'A' && evntLog.schdDt !== null"><time datetime="">{{evntLog.schdDt}}</time></span>
                        <span class="item">
                            <template v-if="chkDiffRprt"><ins>{{evntLog.rprtYn == 'Y' ? $t('AUDIT.INSPECTION.SEND_REPORT') : $t('AUDIT.INSPECTION.REPORT_NOT_RECEIVED')}}<!--<template>(<time datetime="">yyyy-mm-dd 00:00:00 발송</time>)</template>--></ins></template>
                            <template v-else>{{evntLog.rprtYn == 'Y' ? $t('AUDIT.INSPECTION.SEND_REPORT') : $t('AUDIT.INSPECTION.REPORT_NOT_RECEIVED')}}<!--<template>(<time datetime="">yyyy-mm-dd 00:00:00 발송</time>)</template>--></template>
                        </span>
                    </td>
                </tr>
                <tr v-if="isShowAccount">
                    <th>{{ $t('AUDIT.INSPECTION.EVAL_SCOPE')}}<!--검사 범위--></th>
                    <td>
                        <span v-for="acc of bfEvntLog.accId" class="item">{{acc}}</span>
                    </td>
                    <td>
                        <span v-for="acc of getListAfAccount" class="item">
                            <template v-if="acc.isAdd"><ins>{{acc.value}}</ins></template>
                            <template v-else><span v-bind:class="acc.isDelete ? 'delete-region' : ''">{{acc.value}}</span></template>
                        </span>
                    </td>
                </tr>
                <tr v-if="isShowRegion">
                    <th>{{ $t('AUDIT.INSPECTION.EVAL_REGION')}}</th>
                    <td>
                        <span v-for="region of bfEvntLog.regionNm" class="item">{{region}}</span>
                    </td>
                    <td>
                        <span v-for="region of getListAfRegion" class="item">
                            <template v-if="region.isAdd"><ins>{{region.value}}</ins></template>
                            <template v-else><span v-bind:class="region.isDelete ? 'delete-region' : ''">{{region.value}}</span></template>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.INSPECTION.WHITELIST')}}<!--화이트리스트--></th>
                    <td>
                        <span v-for="wTitl of bfEvntLog.wtlTitl" class="item">{{wTitl}}</span>
                    </td>
                    <td>
                        <span v-for="wTitl of evntLog.wtlTitl" class="item">
                            <template v-if="chkDiffWtlList"><ins>{{wTitl}}</ins></template>
                            <template v-else>{{wTitl}}</template>
                        </span>
                    </td>
                </tr>
                <!--<tr>
                    <th>최근 검사</th>
                    <td>
                        <span class="item" v-if="bfEvntLog.execType == 'A' && bfEvntLog.schdDt !== null"><time datetime="">{{bfEvntLog.schdDt}}</time></span>
                        <span class="item">{{bfEvntLog.execType == 'A'? '자동검사' : '수동검사'}}</span>
                    </td>
                    <td>
                        <span class="item" v-if="evntLog.execType == 'A' && evntLog.schdDt !== null"><time datetime="">{{evntLog.schdDt}}</time></span>
                        <span v-if="chkDiffExecType" class="item"><ins>{{evntLog.execType == 'A'? '자동검사' : '수동검사'}}</ins></span>
                        <span v-else class="item">{{evntLog.execType == 'A'? '자동검사' : '수동검사'}}</span>
                    </td>
                </tr>-->
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    export default {
        name: 'ExpandInspectionUpdate',
        props: ['histItem'],
        data: function() {
          return {
              bfEvntLog: null,
              evntLog: null,
              isExpand: false
          }
        },
        computed: {
            getLocale: function() {
                return this.$i18n.locale
            },
            chkDiffTitl: function() {
                return this.bfEvntLog.plcyTitl !== this.evntLog.plcyTitl
            },
            chkDiffDesc: function() {
                return this.bfEvntLog.plcyDesc !== this.evntLog.plcyDesc
            },
            chkDiffAccountList: function() {
                return typeof(this.bfEvntLog.accId) == 'undefined' && typeof(this.evntLog.accId) == 'undefined'
                    ? false
                    : (typeof(this.bfEvntLog.accId) == 'undefined' && typeof(this.evntLog.accId) != 'undefined')  ||
                        (typeof(this.bfEvntLog.accId) != 'undefined' && typeof(this.evntLog.accId) == 'undefined')
                        ? true
                        : this.bfEvntLog.accId.toString() !== this.evntLog.accId.toString()
            },
            chkDiffWtlList: function() {
                return typeof(this.bfEvntLog.wtlTitl) !== 'undefined' && typeof(this.evntLog.wtlTitl) !== 'undefined'
                    ? this.bfEvntLog.wtlTitl.length !== this.evntLog.wtlTitl.length
                    : (typeof(this.bfEvntLog.wtlTitl) !== 'undefined' && typeof(this.evntLog.wtlTitl) === 'undefined') || (typeof(this.bfEvntLog.wtlTitl) === 'undefined' && typeof(this.evntLog.wtlTitl) !== 'undefined')
            },
            chkDiffExecType: function() {
                return this.bfEvntLog.execType !== this.evntLog.execType
            },
            chkDiffRprt: function() {
                return this.bfEvntLog.rprtYn !== this.evntLog.rprtYn
            },
            chkDiffRegionList: function() {
                return typeof(this.bfEvntLog.regionNm) == 'undefined' && typeof(this.evntLog.regionNm) == 'undefined'
                    ? false
                    : (typeof(this.bfEvntLog.regionNm) == 'undefined' && typeof(this.evntLog.regionNm) != 'undefined')  ||
                        (typeof(this.bfEvntLog.regionNm) != 'undefined' && typeof(this.evntLog.regionNm) == 'undefined')
                        ? true
                        : this.bfEvntLog.regionNm.toString() !== this.evntLog.regionNm.toString()
            },
            isShowAccount: function() {
                return (this.bfEvntLog.accId || []).length > 0 || (this.evntLog.accId || []).length > 0; 
            },
            isShowRegion: function() {
                return (this.bfEvntLog.regionNm || []).length > 0 || (this.evntLog.regionNm || []).length > 0; 
            },
            getListAfRegion: function() {
                let tempBfRegion = this.bfEvntLog.regionNm;
                let tempAfRegion = this.evntLog.regionNm;
                let listDeleteRegion = [];
                let listAfRegion = [];
                (tempBfRegion || []).forEach(bfRegion => {
                    if (_.indexOf(tempAfRegion, bfRegion) === -1) {
                        listDeleteRegion.push({
                            isDelete: true,
                            value: bfRegion
                        });
                    } 
                });

                (tempAfRegion || []).forEach(afRegion => {
                    if (_.indexOf(tempBfRegion, afRegion) != -1) {
                        listAfRegion.push({
                            isAdd: false,
                            value: afRegion
                        });
                    } else {
                        listAfRegion.push({
                            isAdd: true,
                            value: afRegion
                        });
                    }
                });

                listAfRegion = listAfRegion.concat(listDeleteRegion);
                return _.orderBy(listAfRegion, ['value'], ['asc']);
            },
            getListAfAccount: function() {
                let tempBfAcc = this.bfEvntLog.accId;
                let tempAfAcc = this.evntLog.accId;
                let listDeleteAcc = [];
                let listAfAcc = [];
                (tempBfAcc || []).forEach(bfAcc => {
                    if (_.indexOf(tempAfAcc, bfAcc) === -1) {
                        listDeleteAcc.push({
                            isDelete: true,
                            value: bfAcc
                        });
                    } 
                });

                (tempAfAcc || []).forEach(afAcc => {
                    if (_.indexOf(tempBfAcc, afAcc) != -1) {
                        listAfAcc.push({
                            isAdd: false,
                            value: afAcc
                        });
                    } else {
                        listAfAcc.push({
                            isAdd: true,
                            value: afAcc
                        });
                    }
                });

                listAfAcc = listAfAcc.concat(listDeleteAcc);
                return _.orderBy(listAfAcc, ['value'], ['asc']);
            }

        },
        methods: {
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.evntLog == null ? this.parseEvntLog() : false

            },
            parseEvntLog: function() {
                if(typeof(this.histItem.bfEvntLog) !== 'undefined'){
                    this.bfEvntLog =  JSON.parse(this.histItem.bfEvntLog)
                    this.bfEvntLog = this.getHeadData(this.bfEvntLog)
                    this.bfEvntLog.regionNm =  _.orderBy(this.bfEvntLog.regionNm, [], ['asc']);
                    this.bfEvntLog.accId =  _.orderBy(this.bfEvntLog.accId, [], ['asc']);
                }
                if(typeof(this.histItem.evntLog) !== 'undefined'){
                    this.evntLog = JSON.parse(this.histItem.evntLog)
                    this.evntLog = this.getHeadData(this.evntLog)
                }

            },
            getHeadData: function(log){
                log.plcyTitl = _.head(log.plcyTitl)
                log.plcyDesc = _.head(log.plcyDesc)
                log.execType = _.head(log.execType)
                log.rprtYn = _.head(log.rprtYn)
                log.schdDt = typeof(log.schdDt) !== 'undefined' ? _.head(log.schdDt) : null

                return log
            },
            getAuditName(hist) {
                if (this.histItem.evntLog) {
                    var lang = JSON.parse(this.histItem.evntLog)[this.$i18n.locale+'Title'];
                    if (lang) {
                        return lang[0];
                    }
                }
                return  hist.prgrSetNm;
            }
        }

    }
</script>
<style scoped>
.delete-region {
    color: #999999;
    text-decoration: line-through;
    line-height: 1.63636em;
    border: 1px dashed #DFE3E8;
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/audit/expand/inspectionUpdate.vue